/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const fragmentsPermissions = {
    "Fragments_SocialPublish": "fragments:fragments:social-publish",
    "Fragments_Delivery": "fragments:fragments:delivery"
} as const;

export type PermissionsIdsDtoFragmentsPermissionsEnum = (typeof fragmentsPermissions)[keyof typeof fragmentsPermissions];

export type PermissionsIdsDto = {
    /**
     * @description Available permissions for the fragments provider
     * @type string
    */
    FragmentsPermissions: PermissionsIdsDtoFragmentsPermissionsEnum;
};